import { Button, Input, message, Modal, Upload } from "antd";
import { useState } from "react";
import { serverFetch } from "@server";

const MessagesItem = ({ visible, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [sendData, setSendData] = useState({ phone: "", text: "", fileName: null, fileBase64: null });

  const handleFileChange = (info) => {
    if (info.file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result.split(',')[1];
        setSendData({...sendData, fileName: info.file.name, fileBase64: base64});
      };
      reader.readAsDataURL(info.file);
    }
  };

  const handleSend = () => {
    if (!sendData.phone || !sendData.text) {
      message.warning("Заполните номер телефона и текст сообщения");
      return;
    }
    
    setLoading(true);
    serverFetch("message/MessageSend", { method: "POST", bodyData: sendData })
      .then(() => {
        message.success("Сообщение отправлено");
        handleClose();
        onSuccess && onSuccess();
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage || "Ошибка при отправке");
      });
  };

  const handleClose = () => {
    setSendData({ phone: "", text: "", fileName: null, fileBase64: null });
    onClose && onClose();
  };

  return (
    <Modal title="Отправка сообщения" open onOk={handleSend} 
      onCancel={handleClose} okText="Отправить" cancelText="Отмена" confirmLoading={loading}>
      <div style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <label>Номер телефона:</label>
          <Input value={sendData.phone} onChange={e => setSendData({...sendData, phone: e.target.value})} 
            placeholder="+7XXXXXXXXXX" style={{ marginTop: 8 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Текст сообщения:</label>
          <Input.TextArea value={sendData.text} onChange={e => setSendData({...sendData, text: e.target.value})} 
            placeholder="Введите текст сообщения" rows={4} style={{ marginTop: 8 }} />
        </div>
        <div>
          <Upload beforeUpload={() => false} onChange={handleFileChange} showUploadList={false} style={{ marginTop: 8 }}>
            <Button>Выбрать файл</Button>
          </Upload>
          {sendData.fileName && <div style={{ marginTop: 8, color: '#666' }}>Выбран: {sendData.fileName}</div>}
        </div>
      </div>
    </Modal>
  );
};

export default MessagesItem;
